import { useState, useCallback } from "react";
import { IRackTagPrintRequest } from "../typings/interfaces/print/rack-tag-print-request";

const TAG_PRINT_URL = "http://localhost:8535/api/tag-printer/print";

type TagPrinterStatus = "idle" | "printing" | "error";
type LastError = { code: string; message: string } | null;

const useTagPrinter = () => {
  const [status, setStatus] = useState<TagPrinterStatus>("idle");
  const [lastError, setLastError] = useState<LastError>(null);

  const printRackTag = useCallback(
    async (data: IRackTagPrintRequest): Promise<boolean> => {
      setStatus("printing");
      setLastError(null);
      try {
        const res = await fetch(TAG_PRINT_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
          signal: AbortSignal.timeout(15_000),
        });

        const json = await res
          .json()
          .catch(() => ({ success: false, error: "Invalid response" }));

        if (!json.success) {
          setLastError({
            code: "print-failed",
            message: json.error ?? "Print failed.",
          });
          setStatus("error");
          return false;
        }

        setStatus("idle");
        return true;
      } catch (e: any) {
        setLastError({
          code: "network-error",
          message: e?.message ?? "Could not reach tray app.",
        });
        setStatus("error");
        return false;
      }
    },
    []
  );

  const resetError = useCallback(() => setLastError(null), []);

  return {
    printRackTag,
    status,
    lastError,
    resetError,
    isPrinting: status === "printing",
  };
};

export default useTagPrinter;
